import { useEffect, useRef } from "react";
import { whyUsFeatures } from "@/mocks/bbCoffeeData";

export default function WhyUs() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );
    const els = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="experience" ref={sectionRef} className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12 reveal-on-scroll">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 rounded-full">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
            The BeanhoodBrew <span className="text-primary-600">Difference</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            We&apos;re not just another coffee stop. Here&apos;s what makes BB COFFEE special.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyUsFeatures.map((feature, i) => (
            <div
              key={feature.title}
              className="reveal-on-scroll group bg-background-100 hover:bg-background-50 rounded-2xl p-6 md:p-8 transition-all duration-500 hover:-translate-y-2 border border-transparent hover:border-primary-200/50"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-all duration-500 group-hover:rounded-full">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-500`} />
                </div>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}